const swiper1 = new Swiper('#h-custom-collection', {
  // Default parameters
  slidesPerView: 1,
  spaceBetween: 10,
    loop: true,
  
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
      spaceBetween: 30
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 3,
      spaceBetween: 40
    }
  }
});

console.log('yes');


$(document).ready(function() {
  $(".box").click(function() {
    var currentImg = $(this).find("img").attr("src");
    $(".popup img").attr("src", currentImg);
    $(".popup").fadeIn();
    $(".popup").addClass("h-flexs");
    window.scrollTo(500, 0);

  });
  $(".close-btn").click(function() {
    $(".popup").hide().removeClass("h-flexs"); 
   
  });
});